export const countyLegislatures = [
  // "dutchess" is not included because we want both legislative and district offices to show up for Dutchess legislators
  "Nassau County Legislature",
  "Suffolk County Legislature",
  "Orange County Legislature",
  "Putnam County Legislature",
  "Ulster County Legislature",
  "Westchester County Board of Supervisors",
];

// These constants are used to fetch data from Airtable and store it on state in the app.
// The "long" government body strings are passed to the Airtable fetch request url in utilities/apiWrapper.js
// They must exactly match the corresponding view name in Airtable.
// The "short" government body strings must match the keys in the object passed to combineReducers in reducers/index.js
export const governmentBodies = {
  senate: {
    long: "Senate",
    short: "senate",
  },
  assembly: {
    long: "Assembly",
    short: "assembly",
  },
  nyc: {
    long: "NYC Council",
    short: "council",
  },
  nassau: {
    long: "Nassau County Legislature",
    short: "nassau",
  },
  suffolk: {
    long: "Suffolk County Legislature",
    short: "suffolk",
  },
  dutchess: {
    long: "Dutchess County Legislature",
    short: "dutchess",
  },
  orange: {
    long: "Orange County Legislature",
    short: "orange",
  },
  putnam: {
    long: "Putnam County Legislature",
    short: "putnam",
  },
  ulster: {
    long: "Ulster County Legislature",
    short: "ulster",
  },
  westchester: {
    long: "Westchester County Board of Supervisors",
    short: "westchester",
  },
  buffalo: {
    long: "Buffalo Common Council",
    short: "buffalo",
  },
  erie: {
    long: "Erie County Legislature",
    short: "erie",
  },
  rochester: {
    long: "Rochester City Council",
    short: "rochester",
  },
  monroe: {
    long: "Monroe County Legislature",
    short: "monroe",
  },
  niagara: {
    long: "Niagara County Legislature",
    short: "niagara",
  },
};

export const defaultColSize = { sm: [12, 12], md: [4, 4], lg: [4, 4] };

export const genderOptions = [
  { value: "Female", label: "Female" },
  { value: "Nonbinary", label: "Nonbinary" },
  { value: "Male", label: "Male" },
  { value: "Transgender", label: "Transgender" },
  { value: "Unknown", label: "Unknown" },
];
export const raceOptions = [
  { value: "Arab/Asian", label: "Arab/Asian" },
  { value: "Black", label: "Black" },
  { value: "Latine", label: "Latine" },
  { value: "White", label: "White" },
  { value: "Unknown", label: "Unknown" },
];
export const regionOptions = [
  { value: "Capital Region", label: "Capital Region" },
  { value: "Central New York", label: "Central New York" },
  { value: "Finger Lakes", label: "Finger Lakes" },
  { value: "Long Island", label: "Long Island" },
  { value: "Mid-Hudson", label: "Mid-Hudson" },
  { value: "Mohawk Valley", label: "Mohawk Valley" },
  { value: "New York City", label: "New York City" },
  { value: "North Country", label: "North Country" },
  { value: "Southern Tier", label: "Southern Tier" },
  { value: "Western New York", label: "Western New York" },
];

export const races = ["Arab/Asian", "Black", "Latine", "White", "Unknown"];
export const parties = [
  "Democratic",
  "Republican",
  "Conservative",
  "Independent",
  "Undecided",
  "Unknown",
];

export const fieldNames = {
  RACE: "Race",
  LEGISLATIVE_CONFERENCE: "Legislative Conference",
  COMMITTEE_ASSIGNMENTS_AND_CAUCUSES:
    "Lookup Committee Assignments and Caucuses",
  TITLE: "Title",
  LEADERSHIP_TITLE: "Leadership Title",
  CHAIRPERSONSHIP: "Lookup Chairpersonship",
  IN_OFFICE_SINCE: "In Office Since (Year)",
  SEXUAL_ORIENTATION: "Sexual Orientation",
  GENDER: "Gender",
  FACEBOOK: "Facebook",
  INSTAGRAM: "Instagram Handle",
  TWITTER: "Twitter Handle",
  FIRST_NAME: "First Name",
  LAST_NAME: "Last Name",
  FULL_NAME_TITLE: "Full Name, Title",
  PARTY: "Party",
  DISTRICT_REPRESENTED: "District Represented",
  STAFF_RESPONSIBILITY: "Staff Responsibility",
  IMAGE: "Image",
  RANKER_FOR: "Lookup Ranker For",
  VICE_CHAIRPERSONSHIP: "Lookup Vice Chairpersonship",
  DISTRICT_OFFICE_ADDRESS: "Address 1 / District Office",
  CAPITOL_OFFICE_ADDRESS: "Address 2 / Capitol or Legislative Office",
  OTHER_OFFICE_ADDRESS: "Address 3 / Other",
  DISTRICT_OFFICE_PHONE: "Phone 1 / District Office",
  CAPITOL_OFFICE_PHONE: "Phone 2 / Capitol or Legislative Office",
  OTHER_OFFICE_PHONE: "Phone 3 / Other",
  DISTRICT_OFFICE_FAX: "Fax 1 / District Office",
  CAPITOL_OFFICE_FAX: "Fax 2 / Capitol or Legislative Office",
  EMAIL: "Email",
  EMAIL_2: "Email 2",
  WEBSITE: "Website",
  BOROUGH: "Lookup Borough",
  PUBLISH: "Publish",
  REGION: "Lookup Region",
  MAP_IMAGE: "Lookup Map Image",
  VOTING_AGE_POP: "Voting age pop",
  REGISTERED_VOTERS: "Registered voters",
  POC_REGISTRATION: "POC registration",
  TURNOUT_2018: "Turnout 2018",
  TURNOUT_2019: "Turnout 2019",
  TURNOUT_2020: "Turnout 2020",
  TURNOUT_2021: "Turnout 2021",
  PREVIEW: "Preview",
  NEIGHBORHOODS: "Neighborhoods, Cities, and Counties",
};

export const mapDataUrls = {
  nycMapUrl:
    "https://services5.arcgis.com/GfwWNkhOj9bNBqoJ/arcgis/rest/services/NYC_City_Council_Districts/FeatureServer/0/query?where=1=1&outFields=*&outSR=4326&f=pgeojson",
  assemblyMapUrl:
    "https://gisservices.its.ny.gov/arcgis/rest/services/NYS_Assembly_Districts/FeatureServer/0/query?where=1%3D1&objectIds=&time=&geometry=&geometryType=esriGeometryPolygon&inSR=&spatialRel=esriSpatialRelIntersects&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=true&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&gdbVersion=&historicMoment=&returnDistinctValues=false&returnIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&multipatchOption=xyFootprint&resultOffset=&resultRecordCount=&returnTrueCurves=false&returnExceededLimitFeatures=false&quantizationParameters=&returnCentroid=false&sqlFormat=none&resultType=&featureEncoding=esriDefault&datumTransformation=&f=geojson",
  senateMapUrl:
    "https://gisservices.its.ny.gov/arcgis/rest/services/NYS_Senate_Districts/FeatureServer/0/query?where=1%3D1&objectIds=&time=&geometry=&geometryType=esriGeometryPolygon&inSR=&spatialRel=esriSpatialRelIntersects&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=true&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&gdbVersion=&historicMoment=&returnDistinctValues=false&returnIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&multipatchOption=xyFootprint&resultOffset=&resultRecordCount=&returnTrueCurves=false&returnExceededLimitFeatures=false&quantizationParameters=&returnCentroid=false&sqlFormat=none&resultType=&featureEncoding=esriDefault&datumTransformation=&f=geojson",
  nassauMapUrl:
    "https://services1.arcgis.com/rsOafHhKLHpnpr4t/arcgis/rest/services/Nassau_Legislative_Districts_2020/FeatureServer/0/query?where=1%3D1&objectIds=&time=&geometry=&geometryType=esriGeometryPolygon&inSR=&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Meter&relationParam=&returnGeodetic=false&outFields=*&returnGeometry=true&returnCentroid=false&returnEnvelope=false&featureEncoding=esriDefault&multipatchOption=xyFootprint&maxAllowableOffset=&geometryPrecision=&outSR=&defaultSR=&datumTransformation=&applyVCSProjection=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnQueryGeometry=false&returnDistinctValues=false&cacheHint=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&having=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false&returnExceededLimitFeatures=true&quantizationParameters=&sqlFormat=none&f=pgeojson&token=",
  suffolkMapUrl:
    "https://gis.suffolkcountyny.gov/server/rest/services/LocalGovernmentSQLData/LegislativeDistrict/MapServer/0/query?where=1%3D1&text=&objectIds=&time=&timeRelation=esriTimeRelationOverlaps&geometry=&geometryType=esriGeometryPolygon&inSR=&spatialRel=esriSpatialRelIntersects&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultOffset=&resultRecordCount=&returnExtentOnly=false&sqlFormat=none&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&featureEncoding=esriDefault&f=geojson",
};

export const pages = {
  "": {
    route: "/",
    region: "SENATE",
    menuItem: "VIEW BY PEOPLE",
    title: "State Senate: Legislative Conferences",
  },
  senate: {
    route: "/senate",
    region: "SENATE",
    menuItem: "VIEW BY PEOPLE",
    title: "State Senate: Legislative Conferences",
  },

  "senate-map": {
    route: "/senate-map",
    region: "SENATE",
    menuItem: "VIEW ON MAP",
    title: "State Senate Map",
  },

  assembly: {
    route: "/assembly",
    region: "ASSEMBLY",
    menuItem: "VIEW BY PEOPLE",
    title: "State Assembly: Legislative Conferences",
  },

  "assembly-map": {
    route: "/assembly-map",
    region: "ASSEMBLY",
    menuItem: "VIEW ON MAP",
    title: "State Assembly Map",
  },

  "nyc-council": {
    route: "/nyc-council",
    region: "NYC COUNCIL",
    menuItem: "VIEW BY PEOPLE",
    title: "NYC Council: Borough Delegations",
  },

  "nyc-council-map": {
    route: "/nyc-council-map",
    region: "NYC COUNCIL",
    menuItem: "VIEW ON MAP",
    title: "NYC Council Map",
  },

  dutchess: {
    route: "/dutchess",
    region: "HUDSON VALLEY COUNTIES",
    menuItem: "DUTCHESS",
    title: "Dutchess County Legislature: Conferences",
  },

  orange: {
    route: "/orange",
    region: "HUDSON VALLEY COUNTIES",
    menuItem: "ORANGE",
    title: "Orange County Legislature: Conferences",
  },

  putnam: {
    route: "/putnam",
    region: "HUDSON VALLEY COUNTIES",
    menuItem: "PUTNAM",
    title: "Putnam County Legislature: Conferences",
  },

  ulster: {
    route: "/ulster",
    region: "HUDSON VALLEY COUNTIES",
    menuItem: "ULSTER",
    title: "Ulster County Legislature: Conferences",
  },

  westchester: {
    route: "/westchester",
    region: "HUDSON VALLEY COUNTIES",
    menuItem: "WESTCHESTER",
    title: "Westchester County Legislature: Conferences",
  },

  nassau: {
    route: "/nassau",
    region: "LONG ISLAND COUNTIES",
    menuItem: "NASSAU",
    title: "Nassau County Legislature: Conferences",
  },

  "nassau-map": {
    route: "/nassau-map",
    region: "LONG ISLAND COUNTIES",
    menuItem: "VIEW ON MAP",
    title: "Nassau Map",
  },

  suffolk: {
    route: "/suffolk",
    region: "LONG ISLAND COUNTIES",
    menuItem: "SUFFOLK",
    title: "Suffolk County Legislature: Conferences",
  },

  "suffolk-map": {
    route: "/suffolk-map",
    region: "LONG ISLAND COUNTIES",
    menuItem: "VIEW ON MAP",
    title: "Suffolk Map",
  },

  buffalo: {
    route: "/buffalo",
    region: "WESTERN NY",
    menuItem: "BUFFALO",
    title: "Buffalo Common Council: Conferences",
  },

  erie: {
    route: "/erie",
    region: "WESTERN NY",
    menuItem: "ERIE COUNTY",
    title: "Erie County Legislature: Conferences",
  },

  niagara: {
    route: "/niagara",
    region: "WESTERN NY",
    menuItem: "NIAGARA COUNTY",
    title: "Niagara County Legislature: Conferences",
  },

  rochester: {
    route: "/rochester",
    region: "FINGER LAKES",
    menuItem: "ROCHESTER",
    title: "Rochester City Council: Conferences",
  },

  monroe: {
    route: "/monroe",
    region: "FINGER LAKES",
    menuItem: "MONROE COUNTY",
    title: "Monroe County Legislature: Conferences",
  },
  "terms-of-service": {
    route: "/terms-of-service",
    title: "Terms of Service",
  },
  "privacy-policy": {
    route: "/privacy-policy",
    title: "Privacy Policy",
  },
};
